import { gql } from '@apollo/client';

export const ALL_FUNDER_ACTIVITIES = gql`
  query AllFunderActivities($input: FilteredActivitiesInput) {
    activities: allFunderActivities(input: $input) {
      id
      name
      description
    }
  }
`;
